import { useSelector } from 'react-redux';
import * as userSelectors from '../../user/user-selectors';

/**
 * This hook is used to get current region in context.
 *
 * @param overrideRegion - Optional region to override the current region. Helpful for testing and storybook.
 * @returns The current region.
 */
const useRegion = (overrideRegion?: string): { region: string } => {
  const currentPlace = useSelector(userSelectors.currentCity);

  return {
    region: overrideRegion ?? currentPlace,
  };
};

export default useRegion;
